// Formato de fechas y tiempo de lectura.
//
// Una revista sin fechas visibles parece desactualizada aunque no lo esté. El
// dato ya viene de la base de datos; solo faltaba mostrarlo.

const FORMATO_LARGO = { day: 'numeric', month: 'long', year: 'numeric' };

/** "12 de abril de 2026" */
export const fechaLarga = (valor) => {
  if (!valor) return '';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-PE', FORMATO_LARGO);
};

/**
 * "hace 3 días" para lo reciente, fecha completa a partir de un mes.
 * Lo reciente en relativo transmite actividad; lo antiguo en relativo
 * ("hace 412 días") no dice nada útil.
 */
export const fechaRelativa = (valor) => {
  if (!valor) return '';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return '';

  const segundos = Math.floor((Date.now() - d.getTime()) / 1000);
  if (segundos < 0) return fechaLarga(valor);

  const minutos = Math.floor(segundos / 60);
  const horas = Math.floor(minutos / 60);
  const dias = Math.floor(horas / 24);

  if (minutos < 1) return 'hace un momento';
  if (minutos < 60) return `hace ${minutos} min`;
  if (horas < 24) return `hace ${horas} h`;
  if (dias === 1) return 'ayer';
  if (dias < 30) return `hace ${dias} días`;
  return fechaLarga(valor);
};

/**
 * Minutos de lectura a partir del cuerpo en HTML.
 * 200 palabras por minuto es la referencia habitual para lectura en pantalla.
 */
export const tiempoDeLectura = (html) => {
  if (!html) return 0;
  const contenedor = document.createElement('div');
  contenedor.innerHTML = html;
  const texto = (contenedor.textContent || '')
    .replace(/\u00a0/g, ' ')
    .trim();
  if (!texto) return 0;
  const palabras = texto.split(/\s+/).length;
  return Math.max(1, Math.round(palabras / 200));
};
